import React from 'react'
import Container from 'react-bootstrap/Container';
import './About.css';

function AboutSecond() {
    return (
        <Container>
                <p className="aboutMe">
                    <span className="smalltext">Through dreamy synths filtered in fuzz, sparkly guitars and gentle vocals, freddyboy crafts warm, melodic silhouettes of his ordinary life. His youthful sound playfully swings between introversion and unfazed self-expression, capturing the quiet complexities of growing up in your twenties.</span>
                </p>
        </Container>
    )
}

export default AboutSecond